import { useNavigate, useParams } from "react-router";
import { BuyerInfoStep } from "@/features/reservation/components/BuyerInfoStep";

export default function BuyerInfoPage() {
  const {
    caseToken = "",
    shopId = "",
    productId = "",
  } = useParams<{
    caseToken: string;
    shopId: string;
    productId: string;
  }>();
  const navigate = useNavigate();

  return (
    <BuyerInfoStep
      caseToken={caseToken}
      shopId={shopId}
      productId={productId}
      onBack={() => navigate(`/${caseToken}/${shopId}/${productId}`)}
      onBackToShop={() => navigate(`/${caseToken}/${shopId}`)}
    />
  );
}
